import { useEffect, useState } from 'react';
import { OrgAppRoles } from 'src/types';

const useOrgAppRoleCollapse = (appRoles: OrgAppRoles) => {
  const [collapseAll, setCollapseAll] = useState(true);

  useEffect(() => {
    if (
      appRoles.appRoles.length === 0 ||
      appRoles.appRoles.every((item) => item.expand)
    ) {
      setCollapseAll(true);
    } else if (appRoles.appRoles.every((item) => item.expand === false)) {
      setCollapseAll(false);
    }
  }, [appRoles]);

  return { collapseAll, setCollapseAll };
};

export default useOrgAppRoleCollapse;
